module.exports = __webpack_public_path__ + "static/img/sns.62ca73f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/workspace/sns.png
// module id = xSpd
// module chunks = 1